import axios from '@/utils/axios'

export const getInstallationPersons = (params = {}) => {
  return axios.get('/installation-persons', { params })
}

export const getInstallationPersonById = (id) => {
  return axios.get(`/installation-persons/${id}`)
}

export const getInstallationPersonDropdown = () => {
  return axios.get('/installation-persons/dropdown')
}

export const createInstallationPerson = (data) => {
  return axios.post('/installation-persons', data)
}

export const updateInstallationPerson = (id, data) => {
  return axios.put(`/installation-persons/${id}`, data)
}

export const deleteInstallationPerson = (id) => {
  return axios.delete(`/installation-persons/${id}`)
}